<div class="main">
  <div class="nav-bar">
    <div class="back-holder" (click)="closeCreatePostButton()">لغو</div>
    <div class="nav-bar-title">پست جدید</div>
    <div class="nav-bar-submit" (click)="createPost()">ثبت</div>
  </div>
  <div class="create-post-container">
    <textarea
      [(ngModel)]="text"
      (ngModelChange)="search(); autoGrow()"
      rows="1"
      placeholder="چه خبر؟..."
      id="postTextarea"
      maxlength="2000"
    ></textarea>
    <div
      *ngIf="croppedImage && !showTagView && !showUserView"
      class="create-post-image-holder"
    >
      <img class="create-post-image" src="{{ croppedImage }}" />
      <div class="create-post-remove-image" (click)="removeImage()">
        <div class="create-post-remove-background"></div>
        <img src="assets/blog/close.svg" />
      </div>
    </div>
    <div
      *ngIf="!croppedImage && !showTagView && !showUserView"
      class="create-post-buttons"
    >
      <div class="create-post-button" (click)="openCalorie()">
        <img
          src="assets/general/calorie.png"
          style="width: 48px; height: 48px; right: 24px; top: 16px"
        />
        <div class="create-post-button-title">کالری</div>
      </div>
      <div class="create-post-button" (click)="openMeal()">
        <img
          src="assets/plan/diet3.png"
          style="width: 48px; height: 42px; right: 24px; top: 16px"
        />
        <div class="create-post-button-title">وعده</div>
      </div>
      <div class="create-post-button" (click)="openCropImageView()">
        <img
          src="assets/general/camera.png"
          style="width: 48px; height: 48px; right: 24px; top: 16px"
        />
        <div class="create-post-button-title">عکس</div>
      </div>
      <div class="create-post-button" (click)="openWeight()">
        <img
          src="assets/plan/weightIcon.png"
          style="width: 48px; height: 48px; right: 24px; top: 16px"
        />
        <div class="create-post-button-title">وزن</div>
      </div>
      <div class="create-post-button" (click)="openWater()">
        <img
          src="assets/plan/waterFull.svg"
          style="width: 32px; height: 48px; right: 32px; top: 14px"
        />
        <div class="create-post-button-title">آب</div>
      </div>
      <div class="create-post-button" (click)="openBeforeAfter()">
        <img
          src="assets/blog/before_after.png"
          style="width: 48px; height: 48px; right: 32px; top: 14px"
        />
        <div class="create-post-button-title">قبل/بعد</div>
      </div>
    </div>
    <div *ngIf="showTagView" class="create-post-search-tag-view" id="tagView">
      <p *ngIf="searchedTags.length === 0" class="create-post-center-text">
        تگ مورد نظر یافت نشد
      </p>
      <div class="create-post-tableView" *ngIf="searchedTags.length !== 0">
        <table class="create-post-table create-post-table-striped">
          <tbody>
            <tr
              *ngFor="let tag of searchedTags; let i = index"
              (click)="replaceTagInSearch(tag)"
            >
              <td class="create-post-td">
                <div class="create-post-table-row-img">
                  <p>#</p>
                </div>
                <div class="create-post-table-row-title">
                  {{ tag.title }}
                </div>
                <div class="create-post-table-row-post-count">
                  {{ tag.postCount }} پست
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div *ngIf="showUserView" class="create-post-search-tag-view" id="userView">
      <p *ngIf="searchedUsers.length === 0" class="create-post-center-text">
        کاربر مورد نظر یافت نشد
      </p>
      <div class="create-post-tableView" *ngIf="searchedUsers.length !== 0">
        <table class="create-post-table create-post-table-striped">
          <tbody>
            <tr
              *ngFor="let user of searchedUsers; let i = index"
              (click)="replaceUsernameInSearch(user.userName)"
            >
              <td class="create-post-td">
                <img
                  class="create-post-user-avatar"
                  *ngIf="user.avatarPath !== ''"
                  src="{{ user.avatarPath }}"
                  onerror="this.onerror=null; this.src='assets/blog/avatar.svg'"
                />
                <img
                  class="create-post-user-avatar"
                  *ngIf="user.avatarPath === ''"
                  src="assets/blog/avatar.svg"
                />
                <div class="create-post-user-username">{{ user.userName }}</div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <div *ngIf="showCropImage" class="item-holder" id="croppedImageView">
    <div class="item-nav-bar">
      <div class="item-back-holder" (click)="closeCropImage()">لغو</div>
      <div class="item-title">عکس</div>
    </div>
    <div class="item-main-holder">
      <input
        type="file"
        id="file"
        style="display: none"
        (change)="fileChangeEvent($event)"
      />
      <div *ngIf="!croppedImage" class="crop-submit-holder">
        <div
          [ngClass]="
            isActive
              ? 'submit-box-crop submit-active-crop'
              : 'submit-box-crop submit-disable-crop'
          "
          id="submit-button"
          (click)="runLoading()"
        >
          <div class="submit-title">انتخاب عکس</div>
        </div>
      </div>
      <div *ngIf="imageChangedEvent" class="crop-img-holder">
        <image-cropper
          [imageChangedEvent]="imageChangedEvent"
          [maintainAspectRatio]="true"
          [aspectRatio]="1 / 1"
          [resizeToWidth]="512"
          format="jpeg"
          (imageCropped)="imageCropped($event)"
          (imageLoaded)="imageLoaded()"
          (cropperReady)="cropperReady()"
          (loadImageFailed)="loadImageFailed()"
          class="cropper"
        ></image-cropper>
      </div>
      <div *ngIf="croppedImage" class="crop-submit-holder">
        <div class="rotate-image" (click)="rotateLeft()">
          <img src="assets/blog/rotate.svg" />
        </div>
      </div>
      <div *ngIf="croppedImage" class="crop-submit-holder">
        <div
          [ngClass]="
            isActive
              ? 'submit-box-crop submit-active-crop'
              : 'submit-box-crop submit-disable-crop'
          "
          id="submit-button"
          (click)="setPostImage()"
        >
          <div class="submit-title">ثبت</div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="showCalorieHolder" class="item-holder" id="calorieHolder">
    <div class="item-nav-bar">
      <div class="item-back-holder" (click)="closeCalorie()">لغو</div>
      <div class="item-title">کالری</div>
    </div>
    <div class="item-main-holder">
      <div
        *ngIf="thisWeekCalorie.length !== 0"
        class="cell-header"
        style="background: #2bdc89"
      >
        <div class="cell-header-title">این هفته</div>
      </div>
      <div
        *ngFor="let calorie of thisWeekCalorie"
        class="cell"
        (click)="openCalorieImage(calorie)"
      >
        <div class="cell-title">{{ calorie.title }}</div>
        <div class="cell-description">{{ calorie.value }}</div>
        <img class="cell-more-icon" src="assets/general/left-gray.svg" />
      </div>
      <div
        *ngIf="lastWeekCalorie.length !== 0"
        class="cell-header"
        style="background: #2bdc89"
      >
        <div class="cell-header-title">هفته گذشته</div>
      </div>
      <div
        *ngFor="let calorie of lastWeekCalorie"
        class="cell"
        (click)="openCalorieImage(calorie)"
      >
        <div class="cell-title">{{ calorie.title }}</div>
        <div class="cell-description">{{ calorie.value }}</div>
        <img class="cell-more-icon" src="assets/general/left-gray.svg" />
      </div>
      <div *ngIf="isCalorieEmpty" class="no-item-title">اشتراک‌گذاری کالری</div>
      <div *ngIf="isCalorieEmpty" class="no-item-description">
        برای به اشتراک گذاشتن باید غذای خود را در صفحه برنامه روزانه ثبت کنید.
      </div>
    </div>
  </div>

  <div
    *ngIf="showCalorieImageHolder"
    class="item-holder"
    id="calorieImageHolder"
  >
    <div class="item-nav-bar">
      <div class="item-back-holder" (click)="closeCalorieImage()">لغو</div>
      <div class="item-title">اشتراک گذاشتن</div>
    </div>
    <div class="item-main-holder">
      <canvas class="canvas-holder" id="canvasCreateImage"></canvas>
      <div
        class="canvas-button"
        style="right: calc(50% - 70px)"
        [ngStyle]="{
          border: imageType === 1 ? '2px solid #0073ff' : '2px solid #b9d8ff'
        }"
        (click)="createCalorieDetailImage()"
      >
        <img src="assets/general/bento.png" />
      </div>
      <div
        class="canvas-button"
        style="right: calc(50% - 58px)"
        [ngStyle]="{
          border: imageType === 0 ? '2px solid #0073ff' : '2px solid #b9d8ff'
        }"
        (click)="createCalorieImage()"
      >
        <img src="assets/general/calorie.png" />
      </div>
      <div
        [ngClass]="
          isActive
            ? 'submit-box-create-image submit-active-crop'
            : 'submit-box-create-image submit-disable-crop'
        "
        id="submit-image-button"
        (click)="setPostImage2()"
      >
        <div class="submit-title">ثبت</div>
      </div>
    </div>
  </div>

  <div *ngIf="showMealHolder" class="item-holder" id="mealHolder">
    <div class="item-nav-bar">
      <div class="item-back-holder" (click)="closeMeal()">لغو</div>
      <div class="item-title">وعده</div>
    </div>
    <div class="item-main-holder">
      <div *ngFor="let dayColorie of todayAndYesterdayMeals">
        <div class="cell-header" style="background: #2bdc89">
          <div class="cell-header-title">{{ dayColorie.title }}</div>
          <div class="cell-header-description">{{ dayColorie.value }}</div>
        </div>
        <div
          *ngFor="let meal of dayColorie.meals"
          (click)="openMealImage(dayColorie, meal)"
        >
          <div
            *ngIf="calorieCalculator.calculateFoodLogsCalorie(meal) !== 0"
            class="cell"
          >
            <div class="cell-title">
              {{ findMealPersianName(meal[0].meal) }}
            </div>
            <div class="cell-description">
              {{
                calorieCalculator.calculateFoodLogsCalorie(meal).toFixed(0) +
                  ' کالری'
              }}
            </div>
            <img class="cell-more-icon" src="assets/general/left-gray.svg" />
          </div>
        </div>
      </div>
      <div *ngIf="isMealEmpty" class="no-item-title">اشتراک‌گذاری وعده</div>
      <div *ngIf="isMealEmpty" class="no-item-description">
        برای به اشتراک گذاشتن باید غذای خود را در صفحه برنامه روزانه ثبت کنید.
      </div>
    </div>
  </div>

  <div *ngIf="showMealImageHolder" class="item-holder" id="mealImageHolder">
    <div class="item-nav-bar">
      <div class="item-back-holder" (click)="closeMealImage()">لغو</div>
      <div class="item-title">اشتراک گذاشتن</div>
    </div>
    <div class="item-main-holder">
      <canvas class="canvas-holder" id="canvasCreateImage"></canvas>
      <div
        class="canvas-button"
        style="right: calc(50% - 70px)"
        [ngStyle]="{
          border: imageType === 1 ? '2px solid #0073ff' : '2px solid #b9d8ff'
        }"
        (click)="openCropImageView2()"
      >
        <img src="assets/general/camera.png" />
      </div>
      <div
        class="canvas-button"
        style="right: calc(50% - 58px)"
        [ngStyle]="{
          border: imageType === 0 ? '2px solid #0073ff' : '2px solid #b9d8ff'
        }"
        (click)="createMealDetailImage()"
      >
        <img src="assets/plan/diet3.png" />
      </div>
      <div
        [ngClass]="
          isActive
            ? 'submit-box-create-image submit-active-crop'
            : 'submit-box-create-image submit-disable-crop'
        "
        id="submit-image-button"
        (click)="setPostImage2()"
      >
        <div class="submit-title">ثبت</div>
      </div>
    </div>
  </div>

  <div *ngIf="showWaterHolder" class="item-holder" id="waterHolder">
    <div class="item-nav-bar">
      <div class="item-back-holder" (click)="closeWater()">لغو</div>
      <div class="item-title">آب</div>
    </div>
    <div class="item-main-holder">
      <div *ngFor="let week of waterlogsWeeks; let i = index">
        <div *ngIf="week && week.length !== 0">
          <div class="cell-header" style="background: #1981ff">
            <div class="cell-header-title">{{ waterlogsWeeksTitle[i] }}</div>
          </div>
          <div
            *ngFor="let waterlog of week"
            class="cell"
            (click)="openWaterImage(waterlog)"
          >
            <div class="cell-title">{{ waterlog.title }}</div>
            <div class="cell-description">{{ waterlog.value }}</div>
            <img class="cell-more-icon" src="assets/general/left-gray.svg" />
          </div>
        </div>
      </div>
      <div *ngIf="isWaterEmpty" class="no-item-title">اشتراک‌گذاری آب</div>
      <div *ngIf="isWaterEmpty" class="no-item-description">
        برای به اشتراک گذاشتن باید مقدار آب مصرفی را در صفحه برنامه روزانه وارد
        کنید.
      </div>
    </div>
  </div>

  <div *ngIf="showWaterImageHolder" class="item-holder" id="waterImageHolder">
    <div class="item-nav-bar">
      <div class="item-back-holder" (click)="closeWaterImage()">لغو</div>
      <div class="item-title">اشتراک گذاشتن</div>
    </div>
    <div class="item-main-holder">
      <canvas class="canvas-holder" id="canvasCreateImage"></canvas>
      <div
        class="canvas-button"
        style="right: calc(50% - 70px)"
        [ngStyle]="{
          border: imageType === 1 ? '2px solid #0073ff' : '2px solid #b9d8ff'
        }"
        (click)="openCropImageView2()"
      >
        <img src="assets/general/camera.png" />
      </div>
      <div
        class="canvas-button"
        style="right: calc(50% - 58px)"
        [ngStyle]="{
          border: imageType === 0 ? '2px solid #0073ff' : '2px solid #b9d8ff'
        }"
        (click)="createWaterDetailImage()"
      >
        <img src="assets/plan/waterFull.svg" />
      </div>
      <div
        [ngClass]="
          isActive
            ? 'submit-box-create-image submit-active-crop'
            : 'submit-box-create-image submit-disable-crop'
        "
        id="submit-image-button"
        (click)="setPostImage2()"
      >
        <div class="submit-title">ثبت</div>
      </div>
    </div>
  </div>

  <div *ngIf="showWeightHolder" class="item-holder" id="weightHolder">
    <div class="item-nav-bar">
      <div class="item-back-holder" (click)="closeWeight()">لغو</div>
      <div class="item-title">وزن</div>
    </div>
    <div class="item-main-holder">
      <div *ngFor="let week of weightlogsWeeks; let i = index">
        <div *ngIf="week && week.lenght !== 0">
          <div class="cell-header" style="background: #443d99">
            <div class="cell-header-title">{{ weightlogsWeeksTitle[i] }}</div>
          </div>
          <div
            *ngFor="let weightlog of week"
            class="cell"
            (click)="openWeightImage(weightlog)"
          >
            <div class="cell-title">{{ weightlog.title }}</div>
            <div class="cell-description">{{ weightlog.value }}</div>
            <img class="cell-more-icon" src="assets/general/left-gray.svg" />
          </div>
        </div>
      </div>
      <div *ngIf="isWeightEmpty" class="no-item-title">اشتراک‌گذاری وزن</div>
      <div *ngIf="isWeightEmpty" class="no-item-description">
        برای به اشتراک گذاشتن باید وزن خود را در صفحه برنامه روزانه وارد کنید.
      </div>
    </div>
  </div>

  <div *ngIf="showWeightImageHolder" class="item-holder" id="weightImageHolder">
    <div class="item-nav-bar">
      <div class="item-back-holder" (click)="closeWeightImage()">لغو</div>
      <div class="item-title">اشتراک گذاشتن</div>
    </div>
    <div class="item-main-holder">
      <canvas class="canvas-holder" id="canvasCreateImage"></canvas>
      <div
        class="canvas-button"
        style="right: calc(50% - 70px)"
        [ngStyle]="{
          border: imageType === 1 ? '2px solid #0073ff' : '2px solid #b9d8ff'
        }"
        (click)="openCropImageView2()"
      >
        <img src="assets/general/camera.png" />
      </div>
      <div
        class="canvas-button"
        style="right: calc(50% - 58px)"
        [ngStyle]="{
          border: imageType === 0 ? '2px solid #0073ff' : '2px solid #b9d8ff'
        }"
        (click)="createWeightDetailImage()"
      >
        <img src="assets/plan/weightIcon.png" />
      </div>
      <div
        [ngClass]="
          isActive
            ? 'submit-box-create-image submit-active-crop'
            : 'submit-box-create-image submit-disable-crop'
        "
        id="submit-image-button"
        (click)="setPostImage2()"
      >
        <div class="submit-title">ثبت</div>
      </div>
    </div>
  </div>

  <div
    *ngIf="showBeforeAfterHolder"
    class="item-holder"
    id="beforeAfterImageHolder"
  >
    <div class="item-nav-bar">
      <div class="item-back-holder" (click)="closeBeforeAfter()">لغو</div>
      <div class="item-title">اشتراک گذاشتن</div>
    </div>
    <div class="item-main-holder">
      <app-calendar *ngIf="calander"></app-calendar>

      <div class="beforeAfterCanvas">
        <canvas
          class="canvas-holder"
          style="display: none"
          id="canvasCreateImage"
        ></canvas>

        <img
          src="{{ beforeImage.src }}"
          *ngIf="beforeImage.src"
          class="preview-image-before"
          alt=""
        />
        <img
          src="{{ afterImage.src }}"
          *ngIf="afterImage.src"
          class="preview-image-after"
          alt=""
        />

        <div class="left" (click)="getAfter()">
          <img *ngIf="showAfterIcon" src="assets/general/camera.png" alt="" />
        </div>

        <p class="after-title">بعد</p>
        <div class="date date-left" (click)="setAfterDate()">
          <p *ngIf="!afterTime">انتخاب تاریخ</p>
          <p>
            <span *ngIf="afterTime">
              {{ afterTime }}
            </span>
            <img src="assets/plans/edit.svg" alt="" />
          </p>
        </div>
        <p class="before-title">قبل</p>
        <img src="assets/blog/logo-white.svg" class="beforeAfterLogo" alt="" />
        <div class="right" (click)="getBefore()">
          <img *ngIf="showbeforeIcon" src="assets/general/camera.png" alt="" />
        </div>
        <div class="date date-right" (click)="setBeforeDate()">
          <p *ngIf="!beforeTime">انتخاب تاریخ</p>
          <p>
            <span *ngIf="beforeTime"> {{ beforeTime }}</span>
            <img src="assets/plans/edit.svg" alt="" />
          </p>
        </div>
      </div>
      <div
        [ngClass]="'submit-box-create-image submit-active-crop'"
        id="submit-image-button"
        (click)="setPostImage2()"
      >
        <div class="submit-title">ثبت</div>
      </div>
    </div>
  </div>

  <div *ngIf="showCropImage2" class="item-holder" id="croppedImageView2">
    <div class="item-nav-bar">
      <div class="item-back-holder" (click)="closeCropImage2()">لغو</div>
      <div class="item-title">عکس</div>
    </div>
    <div class="item-main-holder">
      <input
        type="file"
        id="file"
        style="display: none"
        (change)="fileChangeEvent2($event)"
      />
      <div *ngIf="!croppedImage2" class="crop-submit-holder">
        <div
          [ngClass]="
            isActive
              ? 'submit-box-crop submit-active-crop'
              : 'submit-box-crop submit-disable-crop'
          "
          id="submit-button"
          (click)="runLoading()"
        >
          <div class="submit-title">انتخاب عکس</div>
        </div>
      </div>
      <div *ngIf="imageChangedEvent2" class="crop-img-holder">
        <image-cropper
          [imageChangedEvent]="imageChangedEvent2"
          [maintainAspectRatio]="true"
          [aspectRatio]="Ratio"
          [resizeToWidth]="512"
          format="jpeg"
          (imageCropped)="imageCropped2($event)"
          (imageLoaded)="imageLoaded()"
          (cropperReady)="cropperReady()"
          (loadImageFailed)="loadImageFailed()"
          class="cropper"
        ></image-cropper>
      </div>
      <div *ngIf="croppedImage2" class="crop-submit-holder">
        <div class="rotate-image" (click)="rotateLeft()">
          <img src="assets/blog/rotate.svg" />
        </div>
      </div>
      <div *ngIf="croppedImage2" class="crop-submit-holder">
        <div
          [ngClass]="
            isActive
              ? 'submit-box-crop submit-active-crop'
              : 'submit-box-crop submit-disable-crop'
          "
          id="submit-button"
          (click)="setImageForEditing()"
        >
          <div class="submit-title">ثبت</div>
        </div>
      </div>
    </div>
  </div>
</div>
<app-loading-spinner
  *ngIf="progress"
  [progress]="progress"
  [isDone]="progress == 100"
></app-loading-spinner>
